const security = process.env.VUE_APP_URL_SECURITY_API;

export default class Endpoint {
  public static readonly Url = {
    auth: {
      getMenus: `${security}/api/user/menus`
    }
  };
}
